import apiClient from './axios-config';

export const publicApi = {
  getFeatures: () => apiClient.get('/public/features'),
  getPlans: () => apiClient.get('/public/plans'),
  getAcademyCourses: () => apiClient.get('/public/academy-courses'),
  getAcademyCourseByIdOrSlug: (idOrSlug) => apiClient.get(`/public/academy-courses/${idOrSlug}`),
  getAcademyCourseLessons: (courseId) => apiClient.get(`/public/academy-courses/${courseId}/lessons`),
  getEvents: (limit = 10) => apiClient.get(`/public/events?limit=${limit}`),
};
